import { useState, useEffect } from 'react';
import { getManualTranslation } from '../utils/manualTranslations';
export function useTransifexTranslation(text) {
    var _a = useState(text), translatedText = _a[0], setTranslatedText = _a[1];
    var updateTranslation = function () {
        var _a, _b, _c, _d, _e, _f;
        var translated = (_c = (_b = (_a = window.Transifex) === null || _a === void 0 ? void 0 : _a.live) === null || _b === void 0 ? void 0 : _b.translateText) === null || _c === void 0 ? void 0 : _c.call(_b, text);
        if (translated && translated !== text) {
            setTranslatedText(translated);
        }
        else {
            var languageCode = ((_f = (_e = (_d = window.Transifex) === null || _d === void 0 ? void 0 : _d.live) === null || _e === void 0 ? void 0 : _e.getSelectedLanguageCode) === null || _f === void 0 ? void 0 : _f.call(_e)) || 'en';
            setTranslatedText(getManualTranslation(text, languageCode));
        }
    };
    useEffect(function () {
        var _a;
        if (!((_a = window.Transifex) === null || _a === void 0 ? void 0 : _a.live)) {
            return;
        }
        updateTranslation();
        var handleTranslationUpdate = function () { return updateTranslation(); };
        window.Transifex.live.onAfterTranslate(handleTranslationUpdate);
        return function () {
            var _a, _b, _c;
            (_c = (_a = window.Transifex) === null || _a === void 0 ? void 0 : (_b = _a.live).off) === null || _c === void 0 ? void 0 : _c.call(_b, 'onAfterTranslate', handleTranslationUpdate);
        };
    }, [text]);
    return translatedText;
}
